import type { AsyncThunk } from '@reduxjs/toolkit';
import { getBaseUrl, request } from 'src/helpers/thunkApi';

interface ThunkRejectValue {
  actionType?: string;
  status?: number;
  [key: string]: unknown;
}

type RequestThunk = AsyncThunk<unknown, unknown, { rejectValue: ThunkRejectValue }>;

export const getOpenJobs = (signal?: AbortSignal): RequestThunk => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}/api/job-progress-board/open-jobs`,
    contentType: 'json',
    signal,
  },
  'getOpenJobs',
);

export const getPausedNotes = (jobId?: string, signal?: AbortSignal): RequestThunk => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}/api/service-request/job/${jobId}/paused-note`,
    contentType: 'json',
    signal,
  },
  'getPausedNotes',
);
